<template>
    <div class="ma-2">
        <!-- filter -->
        <v-row class="pb-0 pt-1 px-4">
            <v-col cols="12" sm="auto">
			    <slot name="breadcrumbs" :item="true"></slot>
		    </v-col>
            <!-- <v-col cols="12" sm="4" md="2" lg="2" class="px-1">
                <v-autocomplete 
                    v-model="type"
                    :items="offerTypes"
                    item-text="name"
                    item-value="id"
                    dense
                    outlined
                    hide-details
                    clearable
                    :label="$t('inputs.type')"
                />
            </v-col> -->
            <v-col cols="6" sm="4" md="2" lg="2" class="px-1">
                <bee-date-input
                    v-model="from_date"
                    :label="$t('inputs.from-date')"
                    dense
                    hide-details
                    prepend-icon="mdi-calendar"
                    user-menu-picker
                    input-format-order="DD-MM-YYYY"
                />
            </v-col>
            <v-col cols="6" sm="4" md="2" lg="2" class="px-1">
                <bee-date-input
                    v-model="to_date"
                    :label="$t('inputs.from-date')"
                    dense
                    hide-details
                    prepend-icon="mdi-calendar"
                    user-menu-picker
                    input-format-order="DD-MM-YYYY"
                />
            </v-col>
        </v-row>
        <v-row class="py-0 px-3 my-0">
            <v-col v-if="false" cols="6" sm="4" md="2" lg="1" class="px-0" >
                <v-text-field 
                width="100"
                v-model="offer_no"
                :label="$t('AllOffersPage.offer-no')"
                outlined
                dense
                hide-details
                />
            </v-col>
            <v-col cols="6" sm="4" md="2" lg="2" class="px-1">
                <v-autocomplete 
                    v-model="offer_status"
                    :items="[{name: $t('all'), id: null},...offerStatuses]"
                    item-text="name"
                    item-value="id"
                    dense
                    outlined
                    hide-details
                    :label="$t('AllOffersPage.offer-status')"
                    clearable
                />
            </v-col>
            <v-col cols="6" sm="4" md="2" lg="2" class="px-1">
                <v-autocomplete 
                    v-model="account"
                    :items="accounts"
                    item-text="name"
                    item-value="id"
                    dense
                    outlined
                    hide-details
                    :label="$t('inputs.account')"
                    clearable
                />
            </v-col>
            <v-col cols="6" sm="4" md="2" lg="2" class="px-1">
                <v-text-field 
                v-model="validity_days"
                :label="$t('AllOffersPage.validity-days')"
                outlined
                dense
                hide-details
                @keydown.enter="getOffers()"
                />
            </v-col>
            <v-col cols="6" sm="4" md="2" lg="2" class="px-1">
                <v-text-field 
                v-model="payment_terms"
                :label="$t('AllOffersPage.payment-terms')"
                outlined
                dense
                hide-details
                @keydown.enter="getOffers()"
                />
            </v-col>
            <v-col cols="6" sm="4" md="2" lg="2" class="px-1">
                <v-text-field 
                v-model="notes"
                :label="$t('inputs.notes')"
                outlined
                dense
                hide-details
                @keydown.enter="getOffers()"
                />
            </v-col>
            <v-col></v-col>
            <v-col cols="auto">
                <v-btn dark color="blueGray" @click="getOffers()" class="">
                    {{$t('update')}}
                </v-btn>
            </v-col>
        </v-row>

        <bee-handy-table
            ref="table"
            :headers="headers"
            :items="invoices"
            :loading="loading"
            items-page="10"
            pagination-on-scroll
            shown-rows-text=""
            with-columns-divider
            fixed-header
            dense
            zebra
            :height="$vuetify.breakpoint.height - 210"
        >
            <!-- <template v-slot:item.is_posted="{ item }">
                <span :class="item.is_posted ? 'success--text'  : ' unpostedColor--text'">
                    {{ item.is_posted ? $t('posted') : $t('unposted') }}
                </span>
            </template> -->
            <template v-slot:item.actions="{ item }">
                <div class="d-flex justify-end">

                    <v-tooltip bottom>
                        <template v-slot:activator="{on, attrs}">
                            <v-btn 
                                v-on="on"
                                v-bind="attrs"
                                icon 
                                color="success" 
                                @click="redirectToInvoice(item.id)"
                            >
                                <v-icon>
                                    mdi-eye
                                </v-icon>
                            </v-btn>
                        </template>
                        عرض
                    </v-tooltip>

                </div>
            </template>
    </bee-handy-table>
    </div>
</template>
<script>
import  moment from 'moment'
import { offerStatuses, offerType } from '@/helpers/enums'
import { mapGetters, mapState } from 'vuex'
export default {
    data() {
        return {
            type: null,
            items: [],
            loading: false,
            invoices: [],
            offerType,
            offerStatuses,
            itemId: null,
            from_date: moment().format('YYYY-MM-DD'),
            to_date: moment().format('YYYY-MM-DD'),
            notes: null,
            offer_status: null,
            account: null,
            offer_no: null,
            validity_days: null,
            payment_terms: null
        }
    },

    watch: {
        '$route.query.type'(val) {
            if(val) {
                this.type = val
            }
        }
    },

    computed: {
        headers() {
            return [
                {
                    text: this.$t('headers.no'),
                    name: 'offer-no',
                    value: 'no',
                    width: 40,
                    sortable: false
                },
                {
                    text: this.$t('headers.account'),
                    name: 'account',
                    value: 'account_id',
                    width: '18%',
                    setValueExpr: val => this.getAccountById(val)?.name,
                    sortable: false
                },
                {
                    text: this.$t('AllOffersPage.offer-status'),
                    name: 'status',
                    value: 'status',
                    type: 'number',
                    width: 130,
                    setValueExpr: val => this.offerStatuses.find(v => v.id === val)?.name,
                    noNotAvailableText: true,
                    sortable: false
                },
                {
                    text: this.$t('headers.total'),
                    name: 'total',
                    value: 'total_net.amount',
                    width: 100,
                    sortable: false
                },
                {
                    text: this.$t('AllOffersPage.payment-terms'),
                    name: 'payment-terms',
                    value: 'payment_terms',
                    width: '20%',
                    sortable: false
                },
                {
                    text: this.$t('AllOffersPage.validity-days'),
                    name: 'validity-days',
                    value: 'validity_days',
                    width: '20%',
                    sortable: false
                },
                {
                    text: this.$t('headers.notes'),
                    name: 'notes',
                    value: 'notes',
                    width: '20%',
                    sortable: false
                },
                {
                    text: this.$t('headers.date'),
                    name: 'date',
                    value: 'date',
                    width: 110,
                    sortable: false
                },
                {
                    text: '',
                    name: 'actions',
                    value: 'actions',
                    divider: false,
                    width:50,
                    sortable: false
                },
            ]
        },
        ...mapGetters({
            getAccountById: 'configs/getAccountById',
            getSettingByKey: 'settings/getSettingByKey'
        }),
        ...mapState({
            accounts: state => state.configs.configs.accounts,
            configs: state => state.configs.configs
        }),
        // offerTypes() {
        //     let invoices = offerTypes
        //     invoices.unshift({
        //         name: this.$t('all'),
        //         id: 0
        //     })
        //     return invoices
        // },
        // invoiceStatus() {
        //     let status = this.postingPattern? invoicesPostingTypeStatuses:invoiceStatuses;
        //     status.unshift({
        //         name: this.$t('all'),
        //         id: !this.postingPattern? 0: null
        //     })
        //     return status
        // },
    },

    methods: {
        moment,
        getOffers() {
            this.loading = true
            this.$store.dispatch('offers/searchOffers', { 
                priceOfferType: this.type || null,
                notes :this.notes ,
                accountId: this.account,
                priceOfferStatus: this.offer_status,
                validityDays: this.validity_days,
                paymentTerms: this.payment_terms,
                fromDate: this.from_date,
                toDate: this.to_date,
                no: this.offer_no
            }).then((data) => {
                // this.$refs.table.resetShownRows()
                this.invoices = data
                this.from_date = this.configs.financial_file.start_date;
            }).finally(() => {
                this.loading = false
            })
        },
        redirectToInvoice(id) {
            const route = this.$router.resolve({
                name: 'price-offer',
                params: { id: id }
            });
            window.open(route.href, '_blank');
        },
        redirectToOrder(id) {
            const route = this.$router.resolve({
                name: 'buy-order',
                params: {id: id}
            })
            window.open(route.href, '_blank');
        }
    },
    mounted() {
        /*when come from one of invoices to show un posted invoices*/
        this.from_date = moment(this.configs.financial_file.start_date).format('YYYY-MM-DD');
        this.type  = +this.$route.query.type || 0
        this.offer_status = +this.$route.query.status || null
        this.getOffers()
    }
}
</script>
<style >
</style>